import { render } from "./TotalsView.vue?vue&type=template&id=a1a57c50&scoped=true"
import script from "./TotalsView.vue?vue&type=script&lang=js"
export * from "./TotalsView.vue?vue&type=script&lang=js"

import "./TotalsView.vue?vue&type=style&index=0&id=a1a57c50&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1a57c50"]])

export default __exports__